<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-spacer
      .text-xl.font-bold.ml-10 Photo
      v-spacer
      v-btn(icon @click="showDialog = false" small color="primary")
        v-icon mdi-close
    v-divider

    v-card-text.primary--text.px-6.pt-6.pb-10
      .text-md.font-semibold.mb-4 Upload photo
      v-card.round-xl.border-dashed.pa-8(link outlined)
        .text-center
          v-avatar.mb-3(color="neutral300" size="40")
            v-icon(color="neutral500" size="18") $yzi-image-01
          .mb-1.text-sm 
            span.font-semibold.info--text Click to upload 
            | or drag and drop
          .text-xs.neutral500--text JPG and PNG (max. 4MB)
        input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")

      template(v-for="photo in photos")
        v-card.d-flex.pa-2.round-xl.mt-2(outlined)
          .flex-grow-0.mr-4
            v-img(width="40" height="40" :src="photo.data" fill)
          .text-sm.flex-grow-1
            .font-medium {{ photo.file.name }}
            .neutral500--text {{ photo.file.size | bytesToSize }} - {{ photo.progress }}% {{ $t('uploaded') }}
          v-progress-circular(size="22" width="3" :value="photo.progress" color="#0D6EFF")

      template(v-for="document in documents")
        v-card.d-flex.pa-2.round-xl.mt-2.align-center(outlined)
          .flex-grow-0.mr-4
            v-img.round-md.mr-2(width="40" height="40" :src="$options.filters.smallImage(document.file)" cover)
          .text-sm.flex-grow-1
            .font-medium {{ document.filename }}   

    v-divider
    v-card-actions.py-4.px-6
      v-btn.button-md.underline.px-0(@click="showDialog = false" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="done" color="primary" depressed) {{ $t('done') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { resizeImage } from '@/utils'

export default {
  name: 'UploadPhotoDialog',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    transaction: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    photos: []
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
    documents () {
      return this.transaction?.documents ?? []
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], `photo_${Date.now()}.jpeg`)
      const photo = {
        data: resizedImage.dataURL,
        file: resizedImage.file,
        progress: 0
      }
      this.photos.push(photo)
      this.uploadPhoto(photo)
    },
    uploadPhoto (photo) {
      const formData = new FormData()
      formData.append('file', photo.file)
      this.$axios.patch(`/transactions/${this.transaction.uid}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: progressEvent => (photo.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total))
      }).then(resp => {
        this.photos.pop(photo)
        this.$emit('updated', resp.data)
      }).catch(() => {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      })
    },
    done () {
      this.showDialog = false
    }
  }
}
</script>

<style scoped>
.file-layout {
  position: relative;
  cursor: pointer;
  border: var(--v-neutral400) dashed 1px;
}
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}
</style>